import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Scheduler.SchedulerYear', {
    everyYear: 'Every year',
    everyYearsStartingIn: '<b>[ N ]</b> year(s) starting in <b>[ Year ]</b>',
    specificYear: 'Specific years',
    everyYearBetween: '<b>[ Year ]</b> and <b>[ Year ]</b>',
    every: 'Every ',
    yearBetween: 'Every year between ',
    and: 'and ',
    startingYear: 'year(s) starting in',
    includeYears: 'Include years',
    excludeYears: 'Exclude following years',
    to: 'to',
    yearScheduler: 'Year scheduler',
});
